import React, {useState, memo} from "react";
import {useNavigate} from "react-router-dom";
import {r} from "@/utils/responsive";
import {useNav} from "@/hooks/useNav";
import {createRelativeClipPath} from "@/utils/svgPathConverter";
import ShortcutReforge from "@/components/ShortcutReforge";
import {useShortcuts} from "@/hooks/useShortcuts";
import ExitModalConfirm from "@/components/ExitModalConfirm";
import {progressActions} from "@/stores/progressStore";

interface TopInfoPanelProps extends React.HTMLAttributes<HTMLDivElement> {
}

const TopInfoPanel: React.FC<TopInfoPanelProps> = ({className, ...props}) => {
    const {navigateToSection, currentSection} = useNav()
    const [showExitModal, setShowExitModal] = useState<boolean>(false);

    const handleConfirm = async () => {
        // Сбрасываем прогресс и очищаем localStorage
        progressActions.resetProgress();
        // Устанавливаем шаг 1 для корректной работы с бэкендом (теперь это async)
        await progressActions.setCurrentStep(1);
        // Переходим на начальный экран
        navigateToSection('screensaver');
    };

    useShortcuts({
        onEscape: () => {
            setShowExitModal(() => !showExitModal);
        },
        onEnter: async () => {
            if (showExitModal) {
                await handleConfirm()
            }
        },
        enabledSections: ['briefing', 'editor', 'end', 'intro_text', 'intro_universe', 'screensaver', 'share']
    });
    return (
        <div
            {...props}
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                color: "rgba(255, 255, 255, 1)",
                zIndex: 9999,
                width: "100%",
                height: "100%",
            }}
        >
            <div
                style={{
                    position: "absolute",
                    display: "flex",
                    justifyContent: "space-between",
                    top: 0,
                    left: 0,
                    right: 0,
                    paddingTop: r.vmax(3),
                    paddingLeft: r.vmax(16),
                    paddingRight: r.vmax(20),
                }}
            >
                <h1
                    style={{
                        fontSize: r.vmax(26),
                        lineHeight: r.vmax(44),
                        letterSpacing: r.vmax(-0.2),
                        margin: 0,
                        pointerEvents: "none",
                        userSelect: "none",
                    }}
                >
                    Спасение Контейнерленда
                </h1>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: r.vmax(12),
                }}>
                    <button
                        onClick={async () => {
                            if (currentSection === 'share') {
                                progressActions.resetProgress();
                                await progressActions.setCurrentStep(1);
                                navigateToSection('screensaver');
                            } else {
                                setShowExitModal(true);
                            }
                        }}
                        style={{
                            fontSize: r.vmax(26),
                            lineHeight: r.vmax(44),
                            letterSpacing: 0,
                            margin: 0,
                            cursor: "pointer",
                            userSelect: "none",
                            background: "transparent",
                            border: "none",
                            color: "inherit",
                        }}
                    >
                        {currentSection === 'share' ? `Начать заново` : `Выйти из игры`}
                    </button>
                    <ShortcutReforge isMedium>ESC</ShortcutReforge>
                </div>
            </div>
            <ExitModalConfirm
                isOpen={showExitModal}
                onClose={() => setShowExitModal(prev => !prev)}
                onConfirm={() => handleConfirm()}
            />
        </div>
    );
};

export default memo(TopInfoPanel);
